import React from 'react';

interface ResearchHotIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const ResearchHotIcon: React.FC<ResearchHotIconProps> = ({
  className = '',
  width = 12,
  height = 12,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M3.762 12c-.8-1.664-.374-2.618.24-3.516a5.6 5.6 0 00.847-1.958s.53.688.318 1.764c.935-1.04 1.11-2.699.97-3.334C8.25 6.433 9.153 9.63 7.936 12c6.473-3.662 1.61-9.142.763-9.76.282.617.336 1.662-.234 2.17C7.5.75 5.114 0 5.114 0c.282 1.887-1.023 3.95-2.282 5.493-.044-.753-.091-1.272-.487-1.992C2.256 4.868 1.212 5.982.93 7.35.545 9.208 1.216 10.566 3.762 12V12z" />
    </svg>
  );
};

export default ResearchHotIcon;
